import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { get, map } from "lodash/fp.js";
import { ActionRequest } from "../_globalTypes/index.js";
import { ActionRequestsContainer } from "./actionRequestsStyles.js";
import { CustomAccordion } from "../reusableComponents/CustomAccordion/index.js";
import { Section } from "../reusableComponents/Section/index.js";
import { ActionHeader } from "./actionHeader/index.js";
import ActionCardContent from "./actionCardContent/index.js";
import { retrieveActionRequestLoadingStatus } from "../../selectors/index.js";

const NO_ACTION_REQUIRED =
  "You have no current action requests to review at this time.";
const IsLoading = () => <Section title="Data Loading..." />;

const ActionRequests = ({ actions, isBeingReviewed }) => {
  const [availableActionRequests, setAvailableActionRequests] = useState(false);
  const dataIsLoading = useSelector(retrieveActionRequestLoadingStatus);

  useEffect(() => {
    if (actions.length > 0) {
      setAvailableActionRequests(true);
    }
  }, [actions]);

  const actionElements = useMemo(
    () =>
      map((action) => ({
        ...action,
        isBeingReviewed,
      }))(actions),
    [JSON.stringify(actions)]
  );

  const showActionRequests = () => {
    return (
      <Section
        title={actions.length === 1 ? "Action Request" : "Action Requests"}
      >
        <ActionRequestsContainer>
          {availableActionRequests ? (
            <CustomAccordion
              elements={actionElements}
              keyGetter={get("id")}
              headerComponent={ActionHeader}
              contentComponent={ActionCardContent}
            />
          ) : (
            <p>{NO_ACTION_REQUIRED}</p>
          )}
        </ActionRequestsContainer>
      </Section>
    );
  };

  return dataIsLoading ? <IsLoading /> : showActionRequests();
};

ActionRequests.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape(ActionRequest)).isRequired,
  isBeingReviewed: PropTypes.bool.isRequired,
};

export default ActionRequests;
